import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <h1>プライバシーポリシー</h1>
      <p>
        当サイトは、ユーザーの個人情報を適切に保護することを目的として以下の方針を定めます。
      </p>

      <h2>1. 個人情報の利用目的</h2>
      <p>
        当サイトでは、サービス提供やお問い合わせ対応のために必要な範囲で個人情報を利用します。
      </p>

      <h2>2. 個人情報の第三者提供</h2>
      <p>
        法令に基づく場合を除き、本人の同意なしに第三者へ提供することはありません。
      </p>

      <h2>3. Cookieの使用</h2>
      <p>
        当サイトでは、利便性向上やアクセス解析のためにCookieを使用する場合があります。
      </p>

      <p>制定日：2025年10月28日</p>
    </div>
  );
};

export default PrivacyPolicy;
